module.exports = __webpack_public_path__ + "media/images/team/isa-e080337abe7b1c6afc21c41b58d116f2.jpg";